import React, { useState } from 'react';
import { PermissionButton } from '../../../../../components/Button/PermissionButton';
import { Card } from '../../../../../components/Card/Card';
import GlobalProps from '../../../../../components/globalProps';
import { KeyValueTable } from '../../../../../components/KeyValueTable/KeyValueTable';
import { LoadingPage } from '../../../../../components/LoadingPage/LoadingPage';
import { Modal } from '../../../../../components/Modal/Modal';
import { t } from '../../../../../locales/translate';
import { useRemoteData } from '../../../../../model/data';
import { getEventScannerCodeTypes } from '../../../../../model/event';
import { useErrorHandler } from '../../../../../util/util';
import { ScannerCodeTypesForm } from './ScannerCodeTypesForm';

interface Props extends GlobalProps {
  eventId: string;
}

export function ScannerCodeTypes({ eventId }: Props): JSX.Element {
  const [event, loading, error] = useRemoteData(
    async () => getEventScannerCodeTypes(eventId),
    (db) => db.table('events').find(eventId)
  );
  const [displayModal, setDisplayModal] = useState(false);

  useErrorHandler(error);

  const scannerCodeTypesItems = (event?.scannerCodeTypes?.map((e) => e.toString()).sort() || []).map((e) => {
    const translation = t.model.event._codeTypes[e];
    return { key: translation?.label, value: translation?.description };
  });
  const actions = event
    ? [
        <PermissionButton
          key="edit"
          model={event}
          permission="update_base_attributes"
          name="edit--sm"
          onClick={() => setDisplayModal(true)}
        />,
      ]
    : [];

  return (
    <section className="event-overview__section">
      <Card title={t.model.event.scannerCodeTypes} actions={actions}>
        {loading ? (
          <LoadingPage />
        ) : (
          <KeyValueTable labelWidth={80} emptyMsg={t.model.event.noScannerCodeTypes} items={scannerCodeTypesItems} />
        )}
      </Card>
      <Modal open={displayModal} title={t.model.event.scannerCodeTypes} size="xs">
        <ScannerCodeTypesForm
          eventId={eventId}
          codeTypes={event?.scannerCodeTypes || []}
          onClose={() => setDisplayModal(false)}
        />
      </Modal>
    </section>
  );
}
